<template>
  <div>
    <form @submit.prevent="submit()" class="form">
      <div class="field">
        <label class="label">タイトル</label>
        <div class="control">
          <input class="input" type="text" v-model="form.title">
        </div>
        <p class="help">例）法人ユーザー向けアンケート</p>
      </div>

      <b-field label="公開終了日">
        <b-datepicker
          placeholder="選択してください"
          v-model="form.expires_at"
          :min-date="new Date()"
          :month-names="monthNames"
          :day-names="dayNames"
          :date-formatter="dateFormatter"
        />
      </b-field>

      <b-field label="公開先">
        <b-select
          v-model="form.environment_id"
          placeholder="選択してください"
          expanded
        >
          <option
            v-for="environment in environments"
            :key="environment.id"
            :value="environment.id"
          >{{environment.value}}</option>
        </b-select>
      </b-field>

      <button class="button is-primary" type="submit">作成</button>
    </form>
  </div>
</template>

<script>
import axios from '@/axios'
import moment from 'moment'

export default {
  data() {
    return {
      monthNames: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
      dayNames: ["日", "月", "火", "水", "木", "金", "土"],
      dateFormatter: (date) => moment(date).format('YYYY年MM月DD日'),
      form: {
        title: '',
        expires_at: moment().add('1', 'month').toDate(),
        environment_id: null,
      },
      environments: []
    }
  },

  created() {
    this.fetchEnvironments()
  },

  methods: {
    submit() {
      axios.post('/api/app/surveys', this.form).then(() => {
        this.$router.push('/app/surveys')
      })
    },

    fetchEnvironments() {
      axios.get('/api/app/environments').then(({ data }) => {
        this.environments = data
      })
    }
  }
}
</script>

<style scoped>
.form {
  width: 500px;
  margin: 0 auto;
}
</style>
